import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }



import DropDown from "@/components/DropDown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableDropdown',
  props: {
    entries: {},
    title: {},
    selectedValue: {},
    isEditable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.isEditable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DropDown, {
          "selected-value": props.selectedValue,
          onSelect: _cache[0] || (_cache[0] = (t) => _ctx.$emit('select', t)),
          title: props.title,
          entries: props.entries
        }, null, 8, ["selected-value", "title", "entries"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.title), 1))
}
}

})